import { useCallback, useState } from 'react'
import { httpsCallable } from 'firebase/functions'
import { getFns } from '../../../firebase'

export function useCodeGenerator() {
  const [generating, setGenerating] = useState(false)
  const [error, setError] = useState('')

  const generateCode = useCallback(async ({ mode, typeKey, existingReference }) => {
    setGenerating(true)
    setError('')
    try {
      const fn = httpsCallable(getFns(), 'productListingGenerateCodesV1')
      const res = await fn({ mode, typeKey, existingReference })
      return res?.data || null
    } catch (err) {
      const message = err?.message || err?.details || 'Failed to generate code'
      setError(String(message))
      throw err
    } finally {
      setGenerating(false)
    }
  }, [])

  return {
    generateCode,
    generating,
    error
  }
}

export default useCodeGenerator
